const state = {
  papeis: [
    {
      value: "ADMINISTRADOR",
      label: "Administrador",
    },
    {
      value: "PREFEITURA",
      label: "Prefeitura",
    },
    {
      value: "SOLICITANTE",
      label: "Solicitante",
    },
  ],
}
const getters = {
  papeis(state) {
    return state.papeis
  },
  getLabelPapel(state) {
    return (value) => {
      const papel = state.papeis.find((papel) => papel.value === value)
      return papel !== undefined ? papel.label : value
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
}
